import { jsx as t, jsxs as d, Fragment as u } from "@emotion/react/jsx-runtime";
import { useId as L, useState as j, useCallback as E, useEffect as F } from "react";
import { HEX_COLORS as O } from "@partoohub/branding";
import { StyledLabel as R, StyledToggle as T, StyledCheckbox as q } from "./Switch.styled.js";
import { Icon as v } from "../Icon/index.js";
import { Tooltip as H } from "../Tooltip/index.js";
const g = () => /* @__PURE__ */ t("sup", { children: /* @__PURE__ */ t(v, { icon: ["fa-asterisk"], iconSize: "10px", color: O.danger }) }), B = ({
  dataTrackId: k,
  checked: c = !1,
  disabled: i = !1,
  name: l,
  onChange: a,
  size: h = "small",
  tooltip: x,
  labelPosition: m = "right",
  label: e,
  required: f,
  className: S,
  activeBackgroundColor: I = "success",
  inactiveBackgroundColor: y,
  pillColor: C = "white"
}) => {
  const p = L(), n = `switch-${p}`, [s, o] = j(c), w = E((r) => {
    a ? a?.(r) : o(r.target.checked);
  }, [a, o]);
  return F(() => {
    o(c);
  }, [c, o]), /* @__PURE__ */ t(H, { text: x, children: /* @__PURE__ */ d(R, { "aria-disabled": i, size: h, onClick: (r) => r.stopPropagation(), className: S, htmlFor: e && p ? n : void 0, children: [
    e && m === "left" ? /* @__PURE__ */ d(u, { children: [
      e,
      f ? /* @__PURE__ */ t(g, {}) : null
    ] }) : null,
    /* @__PURE__ */ t(T, { "data-track": k, size: h, "data-checked": s, "data-disabled": i, activeBackgroundColor: I, inactiveBackgroundColor: y, pillColor: C, tabIndex: 0, children: /* @__PURE__ */ t(q, { id: n, "aria-label": e ? void 0 : l ?? n, checked: s, "aria-checked": s, disabled: i, name: l, onChange: w, type: "checkbox" }) }),
    e && m === "right" ? /* @__PURE__ */ d(u, { children: [
      e,
      f ? /* @__PURE__ */ t(g, {}) : null
    ] }) : null
  ] }) });
};
export {
  B as Switch
};
